
<template>
  <div class="container" @click="$emit('click')">
    <div class="randomDiscountAmoutContainer"  v-if="order.randomDiscountAmount && order.randomDiscountAmount > 0">
      {{`本单减免${formatPrice(order.randomDiscountAmount)}`}}
    </div>
    <div class='header'>
      <div class="date">{{formatDateByDate(order.consumeDate)}} </div>
      <div class="period-name"> {{order.periodName + ' - ' + order.hallName}} </div>
      <div class="status">{{resource.orderStatus[order.baseOrderViewStatus]}}</div>
    </div>
    <div class="full-divide" />
    <div class="dishes">
      <div class="dish-item">
        <div class="dish-name hint-color">菜品</div>
        <div class="dish-count hint-color">数量 </div>
        <div class="dish-price hint-color"> 价格</div>
      </div>
      <div v-for="(item, i) in order.dishes" :key="i" class="dish-item">
        <div class="dish-name"> {{item.dishName}}</div>
        <div class="dish-count">{{item.count}} </div>
        <div class="dish-price"> {{formatPrice(item.subtotalPrice)}}</div>
      </div>
    </div>
    <div class="full-divide" />
    <div class="footer" v-if="buttons && buttons.length > 0">
      <div v-for="(item, i) in buttons" :key="i" class="button" :class="item.secondy ? 'secondy' : ''"  @click.stop="handleClick(item.code)">
        {{item.text}}
      </div>
    </div>
    <div v-else class="footer-placeholder"></div>
  </div>
</template>
<script>
import util from '../utils/utils.js'
export default {
  props: {
    order: Object
  },
  computed: {
    buttons () {
      if (this.order.baseOrderViewStatus === 'NOT_PAY') {
        return [{text: '付款', code: 'pay'}, {text: '取消订单', code: 'delete', secondy: true}]
      }
      if (this.order.baseOrderViewStatus === 'NOT_CONSUME') {
        return [{text: '去取餐', code: 'getFood'}, {text: '取消订单', code: 'delete', secondy: true}]
      }
      if (this.order.baseOrderViewStatus === 'CONSUMED') {
        return [{text: '评价', code: 'evaluate'}]
      }
    }
  },
  data () {
    return {
      resource: window.resource
    }
  },
  methods: {
    formatDateByDate: util.formatDateByDate,
    formatPrice: util.formatPrice,
    handleClick (c) {
      this.$emit('buttonClick', {order: this.order, orderId: this.order.orderId, code: c})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
.hint-color
  color $hint-text-color
.randomDiscountAmoutContainer
  padding-top pt(30)
  color #f44336
.container
  background-color white
  margin 30px
  border-radius 20px
  padding 0 pt(25)
  depth(1)
  color $normal-text-color
  font-weight 300
  font-size $small-font-size
  .header
    display flex
    justify-content space-between
    align-items center
    height pt(100)
    .date
      flex-basis pt(170)
    .period-name
      flex-basis pt(200)
    .status
      color $primary-color
      flex-grow 1
      text-align right
  .dishes
    padding pt(10) 0
    .dish-item
      display flex
      align-items center
      margin pt(15) 0
      justify-content space-around
      line-height 100%
      .dish-name
        max-width calc(100% - 240px)
        text-align left
        flex-grow 1
      .dish-count
        flex-basis 80px
        text-align center
      .dish-price
        flex-basis 150px
        text-align right
  .footer
    display flex
    height pt(75)
    align-items center
    flex-direction row-reverse
    .button
      color $primary-color
      padding 0 pt(30)
      margin 0 pt(5)
      border-radius $small-font-size
      border 1px solid
    .secondy
      color $disable-text-color
  .footer-placeholder
    height pt(40)
</style>



// WEBPACK FOOTER //
// order.vue?34cbd398